<template>
  <AdminForm :config="config" :form="form" :isBusy="isBusy" :options="options" @fetchOptions="fetchOptions"
    @resetOptions="resetOptions"></AdminForm>
</template>

<script>
import AdminForm from "@/components/Global/AdminForm";
import config from "./config";
import isOrderableBusiness from "@/components/Business/orderable";

export default {
  name: "RentingForm",
  components: {
    AdminForm,
  },
  props: ["id_to_edit"],
  data() {
    return {
      config: config,
      form: {
        agency_number: null,
        business_number: null,
        employee_number: null,
        status_slug: null,
        products: [{ product_id: null, quantity: null }],
        renting_type_slug: "office",
        status_slug: "renting-non-prise-en-compte",
        axiloc_creation_date: this.$moment().format("YYYY-MM-DD"),
        first_contact_name: null,
        first_contact_phone: null,
        second_contact_name: null,
        second_contact_phone: null,
        renting_retrieving_place: null,
        withdrawal_warehouse_id: null,
      },
      isBusy: false,
    };
  },
  computed: {
    options: function () {
      return {
        renting_retrieving_place_options: this.$store.getters["renting/getRentingRetrievingPlaces"],
        // INC-005 : le site de retrait se choisit, il n'est plus supposé être Carquefou.
        withdrawal_warehouse_id_options: this.$store.getters["warehouse/getAll"].selectOptions(
          "id",
          ["internal_code", " - ", "name"]
        ),
        agency_number_options: this.$store.getters["agency/getAll"].selectOptions(
          "internal_number",
          ["internal_number", " - ", "name"]
        ),
        status_slug_options: this.$store.getters["status/getByGroup"]("renting").selectOptions(
          "status_slug",
          "name"
        ),
        renting_type_slug_options: this.$store.getters[config.storeNamespace + "/getTypes"],
        product_id_options: _.orderBy(
          this.$store.getters["product/getByStatusSlug"]('product_on_sale').selectOptions("id", "name"),
          "text"
        ),
        business_number_options: _.orderBy(
          this.$store.getters["business/getByAgencyNumber"](this.form.agency_number)
            .filter(isOrderableBusiness)
            .selectOptions("number", ["number", " - ", "name"]),
          "text"
        ),
        employee_number_options: _.orderBy(
          this.$store.getters["user/getByAgencyNumberAndStatusSlug"]({
            agency: this.form.agency_number,
            status: "user-active",
          }).selectOptions("employee.number", [
            "firstname",
            " ",
            "lastname",
            " (",
            "employee.number",
            ")",
          ]),
          "text"
        ),
        user_id_options: _.orderBy(
          this.$store.getters["user/getByStatusSlug"]("user-active").selectOptions("id", [
            "firstname",
            " ",
            "lastname",
            " (",
            "employee.number",
            ")",
          ]),
          "text"
        ),
      };
    },
  },
  watch: {
    "form.agency_number": function (agency) {
      this.$store.dispatch("business/getAllForSelectByAgencyNumber", {
        wait: true,
        agency: agency,
      }).then(() => {
        this.options.employee_number_options = this.$store.getters[
          "user/getByAgencyNumberAndStatusSlug"
        ]({ agency: agency, status: "user-active" }).selectOptions("employee.number", [
          "firstname",
          " ",
          "lastname",
          " (",
          "employee.number",
          ")",
        ]);
        this.config.fields.find(item => item.name == 'employee_number').placeholder = '-- Recherchez une option en saisissant les premiers caractères --'
      })
    }
  },
  mounted() {
    let self = this;
    // Duplication
    // Chargement de la copie qui a été préparée s'il y en a une
    const copy = this.$store.getters[config.storeNamespace + "/getCopy"];
    if (!this.id_to_edit && copy && copy.renting_number) {
      this.form = { ...copy };
      this.form.axiloc_creation_date = self.$moment().format("YYYY-MM-DD")
      this.form.status_slug = 'renting-non-prise-en-compte'
      this.form.renting_type_slug = "office"
      this.$store.commit("renting/emptyCopy");

      if (copy.employee_number) {
        this.$store.dispatch("user/getItemByEmployeeNumber", {employee_number: copy.employee_number, add: true});
      }
      if (copy.user_id) {
        this.$store.dispatch("user/getItem", {id: copy.user_id, add: true});
      }

      this.getCopyNumber().then(number => {
        this.form.renting_number = number
      })
    }

    // Edition
    const id =
      this.$route.name == config.editRouteName && this.$route.params.id
        ? this.$route.params.id
        : this.id_to_edit || null;

    if (id) {
      this.isBusy = true;
      this.$store
        .dispatch(config.storeNamespace + "/getItem", {
          id: id,
          wait: true,
        })
        .then(() => {
          let item = _.cloneDeep(this.$store.getters[config.storeNamespace + "/getItem"](id));
          this.form = {
            ...item,
            agency_number: item.agency ? item.agency.internal_number : null,
            business_number: item.business ? item.business.number : null,
            employee_number: item.employee ? item.employee.number : null,
            user_id: item.user ? item.user.id : null,
            withdrawal_warehouse_id: item.withdrawal_warehouse ? item.withdrawal_warehouse.id : null,
            status_slug: item.status ? item.status.status_slug : null,
            required_truck_tailgate: item.required_truck_tailgate || false,
            reachable_by_semitrailer_truck: item.reachable_by_semitrailer_truck || false,
            wished_delivery_date: item.wished_delivery_date
              ? this.$moment(item.wished_delivery_date).format("YYYY-MM-DD")
              : null,
            axiloc_creation_date: item.axiloc_creation_date
              ? this.$moment(item.axiloc_creation_date).format("YYYY-MM-DD")
              : null,
            products: [],
          };
          item.renting_preparations.forEach((renting_preparation) => {
            renting_preparation.products_renting.forEach((product) => {
              self.form.products.push({
                product_id: product.product.id,
                quantity: product.quantity,
              });
            });
            renting_preparation.products_selling.forEach((product) => {
              self.form.products.push({
                product_id: product.product.id,
                quantity: product.quantity,
              });
            });
          });

          this.$store.dispatch("business/getAllForSelectByAgencyNumber", {
            agency: item.agency.internal_number,
          });
            if (item.employee) {
              this.$store.dispatch("user/getItemByEmployeeNumber", {
                employee_number: item.employee.number, add: true
              });
            }
            if (item.user) {
              this.$store.dispatch("user/getItem", {
                id: item.user.id, add: true
              });
            }

          this.isBusy = false;
        });
    }
    // appel l'action getAll du store qui va faire la requete au back pour le stocker en local
    this.$store.dispatch("agency/getAllForSelect");
    this.$store.dispatch("product/getAllForSelect");
    // payload complet : le libellé du select reprend le code interne de l'entrepôt
    this.$store.dispatch("warehouse/getAll");
  },
  methods: {
    fetchOptions(field_name, search, loading) {
      if (field_name == 'employee_number' || field_name == 'user_id') {
        this.$store.dispatch("user/getAllForSelectBySearch", { wait: true, search: search, add: true }).then(() => {
          if (this.form.employee_number && !this.options.employee_number_options.find(item => item.value == this.form.employee_number)) {
            this.$store.dispatch("user/getItemByEmployeeNumber", {
              employee_number: this.form.employee_number,
            });
          }
          if (this.form.user_id && !this.options.user_id_options.find(item => item.value == this.form.user_id)) {
            this.$store.dispatch("user/getItem", {
              id: this.form.user_id, add: true
            });
          }
        })
      }
    },
    resetOptions(field_name) {
      if (this.form.employee_number && !this.options.employee_number_options.find(item => item.value == this.form.employee_number)) {
        this.$store.dispatch("user/getItemByEmployeeNumber", {
          employee_number: this.form.employee_number, add: true
        });
      }
      if (this.form.user_id && !this.options.user_id_options.find(item => item.value == this.form.user_id)) {
        this.$store.dispatch("user/getItem", {
          id: this.form.user_id, add: true
        });
      }
    },
    /**
     * Retourne le prochain numéro de commande incrémenté pour les duplications
     */
    getCopyNumber() {
      var self = this;
      const baseNumber = this.form.renting_number.split('+')[0]

      return new Promise(function (resolve, reject) {
      self.$http
        .get(process.env.BACK_API_URL + "renting", {
          params: {
            page: 1,
            limit: 0,
            search: baseNumber,
          },
        })
        .then((response) => {
          if (response && response.data && response.data.rentings) {
            let counter = 1
            let rentingCounter = null
            response.data.rentings.map(renting => {
              rentingCounter = renting.renting_number.indexOf('+') >= 0 ? renting.renting_number.split('+')[1] : renting.renting_number
              if (rentingCounter && parseInt(rentingCounter) > counter) {
                counter = parseInt(rentingCounter) + 1
              } else if (rentingCounter && parseInt(rentingCounter) == counter) {
                ++counter
              }
            })
            resolve(baseNumber+'+'+counter)
          } else {
            resolve(null)
            self.$toastr.error("Le calcul du numéro a échoué");
          }
        })
        .catch((error) => {
          resolve(null)
          self.$toastr.error("Le calcul du numéro a échoué");
        });
      });
    }
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Renting/RentingForm.vue